import React, { useEffect, useState } from "react";
import styles from "./Journal.module.css";

import { getEntriesForUsermedia, postEntry } from "../../api/Api";
import { Entry } from "../Entry/Entry"
import { NewEntry } from "../Entry/NewEntry";
import { EntryReadingHeader } from "../Entry/EntryReadingHeader";
import { useMedia, useMediaUpdate } from "../../contexts/MediaContext";

export const Journal = () => {

    // ----------------------------------------------------- STATE AND HOOKS

    let token = localStorage.getItem("token");

    const mediaItem = useMedia();
    const setMedia = useMediaUpdate();

    const [isAdding, setIsAdding] = useState(false); // states if new entry is being created
    const [newEntry, setNewEntry] = useState(null); // populated by NewEntry when entry is submitted
    const [editedEntry, setEditedEntry] = useState(null) // populates with updated entry when edited

    useEffect(() => {
        if (newEntry !== null) {
            addEntry();
        }
    },[newEntry]);

    useEffect(() =>{
        // triggers re-render when media item changes
        
    },[mediaItem])


    let entries = makeEntries();

    // ----------------------------------------------------- PRE-RENDER

    async function addEntry() {
        // adds entry to back
        let entryPostModel = {
            title: newEntry.title,
            body : newEntry.body,
            time : new Date,
            page : newEntry.page,
            readingID : newEntry.readingid
        }

        await postEntry(entryPostModel, mediaItem.usermediaid, token)
            .then((media) => {
                setNewEntry(null) // clears newEntry
                setIsAdding(false); // closes new post adder
                // fetchEntries(); // re-fetches entries for ordering
                setMedia(media);
                
            })
            .catch((error) =>{
                console.log("failed to add entry", error);
            })
    }

    function makeEntries () {
        // makes entries and reading headers

        if (mediaItem?.entries === null) return; // no entries, no action

        let entryArray = []; // array of arrays of entries, sorted by reading
        // let seen = []; // array of readingids 

        for (let e = mediaItem.entries?.length-1; e >= 0 ; e--) {
            entryArray.push(<div key={"ENTRYID: "+e}><Entry entryItem = {mediaItem.entries[e]} setEditedEntry={setEditedEntry} /></div>)
        }

        // for (let e = 0; e < mediaItem.entries?.length; e++) {
        //     // collects entries into their readings

        //     if (seen.includes(mediaItem.entries[e].readingid)) {
        //         // if seen reading aleady

        //         // gets index from seen
        //         let index = seen.indexOf(mediaItem.entries[e].readingid)

        //         // adds to array
        //         var temp = []
        //         temp.push(mediaItem.entries[e]);
        //         entryArray[index] = temp;

        //     } else {
        //         // new reading
        //         seen.push(mediaItem.entries[e].readingid);
        //         entryArray.push([mediaItem.entries[e]]);
        //     }

        //     // console.log( entryArray, seen);
    
        // }

        // makes HTML objects
        // let entryObjects = [];
        // for (let i = 0; i < seen?.length; i++) {

           

        // }
            // goes through each reading
            // console.log("making header and entries for reading id: ", seen[i])

            // if (mediaItem.readings?.length === 0) {
            //     // if media has no readings, but does have entries

            // } 
            // else if (seen[i] == 0) {
            //     // not assocaited with reading

            //     // adds entry header for given reading
            //     let temp = [];
            //     temp.push(
            //         <EntryReadingHeader mediaItem={mediaItem} readingItem={null} />
            //     )

            //     // makes objects for entries in entryArry at given index
            //     for (let e = 0; e < entryArray[i].length; e++) {
            //         temp.push (
            //             <Entry entryItem = {entryArray[i][e]} setEditedEntry={setEditedEntry} />
            //         )
            //     }

            //     entryObjects.push(temp)

            // }
        //     else {
        //         // finds reading object
        //         var reading;
        //         for (let r = 0; r < mediaItem.readings?.length; r++) {
        //             if (mediaItem.readings[r].readingid === seen[i]) {
        //                 reading = mediaItem.readings[r];
        //                 break;
        //             }
        //         }

        //         // adds entry header for given reading
        //         let temp = [];
        //         temp.push(
        //             <EntryReadingHeader mediaItem={mediaItem} readingItem={reading} />
        //         )

        //         // makes objects for entries in entryArry at given index
        //         for (let e = 0; e < entryArray[i].length; e++) {
        //             temp.push (
        //                 <Entry entryItem = {entryArray[i][e]} setEditedEntry={setEditedEntry} />
        //             )
        //         }

        //         entryObjects.push(temp)
        //     }

        // }

        return entryArray;

        // // var entryArray = [];
        // let lastSeen = mediaItem.entries[0].readingid;


        // // gets first reading header
        // if (lastSeen !== 0) {

        //     for (let r = 0; r < mediaItem.readings?.length; r++) {
        //         // finds reading
        //         if (mediaItem.readings[r].readingid === lastSeen) {
        //             // adds header to array

        //             entryArray.push(
        //                 <EntryReadingHeader mediaItem={mediaItem} readingItem={mediaItem.readings[r]} />
        //             )

        //         } 
        //     }
        // }


        // for (let i = 0; i < mediaItem.entries?.length; i++) {
        //     // makes entry objects
        //     if (mediaItem.entries[i].readingid !== lastSeen) {
        //         // needs new header

        //         // makes new header
        //         for (let r = 0; r < mediaItem.readings?.length; r++) {
        //             // finds reading
        //             if (mediaItem.readings[r].readingid === mediaItem.entries[i].readingid) {
        //                 // adds header to array
        //                 entryArray.push(
        //                     <EntryReadingHeader mediaItem={mediaItem} readingItem={mediaItem.readings[r]} />
        //                 );

        //                 // updates last seen
        //                 lastSeen = mediaItem.entries[i].readingid;
        //             }
        //         }

        //         // adds entry
        //         entryArray.push (
        //             <Entry entryItem = {mediaItem.entries[i]} setEditedEntry={setEditedEntry} />
        //         );
        //     } else {

        //         // under current header
        //         entryArray.push (
        //             <Entry entryItem = {mediaItem.entries[i]} setEditedEntry={setEditedEntry} />
        //         );
        //     }
        // }


        // return entryArray;


    }


    // ----------------------------------------------------- RENDER
    return (
        <section className={styles.container}>
            <div className={styles.header}>
                <span><h3 className={styles.headerTitle}>Journal</h3></span>
                <button className={styles.plusButton} onClick={ () => setIsAdding(!isAdding) }>
                    <img src="/assets/images/plusIcon.svg" alt="add icon" title="New Entry" className={styles.icon}/>
                </button>
            </div>
            <div className={styles.content}>
                {isAdding ? <NewEntry mediaItem={mediaItem} setNewEntry={setNewEntry} setIsAdding={setIsAdding} /> : null}

                {
                    mediaItem.entries !== null ?
                        <div className={styles.content}>
                            {/* {mediaItem.entries.map((entry) => <div key={entry.entryid}><Entry entryItem={entry} setEdited={setEditedEntry} /></div>)} */}
                            {entries}
                        </div>
                        :
                        <></>
                }
            </div>
            
        </section>
    )
}